import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer, TableRow, Paper,Chip,
  TextField, Select, MenuItem, FormControl, Button, TablePagination,TableFooter,InputAdornment 
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { initHeightObserver } from './iframeUtils';  // Import the script
import SearchIcon from '@mui/icons-material/Search';
import { DeleteForever } from '@mui/icons-material';


const accountSize = 10000; // Variable global "Tamaño de cuenta"

const styles = {
  iconButton: {
    color: '#ff4d4d',
  },
  
};

function JournalTable() {
  const [isBackTesting, setIsBackTesting] = useState(true);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editing, setEditing] = useState({});
  const [token, setToken] = useState(null);
  const [openSelect, setOpenSelect] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    estrategia: '',
    direccion: '',
    resultado: ''
  });
  const resultOptions = [
    { value: 'Stop Loss', color: '#FF3535' },
    { value: 'Take Profit', color: '#16DE42' },
    { value: 'Break Even', color: '#FFDF35' },
    { value: 'Partial', color: '#16DE42' },
  ];
  
  const enviorment = 'https://vps.tradinglab.es/spr/api/records';
  //const enviorment = 'http://localhost:5003/api/records';

  const handleNotasClick = (rowId,isAsr) => {
    // Send a message to the parent window

    console.log()
    window.parent.postMessage({ type: 'openNotes', rowId: rowId, token: token , isAsr : isAsr,row: rows.find(row => row.id === rowId)}, '*');
  };

   const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const fetchRecords = async (token,isBackTesting) => {
    try {
      const response = await axios.get(enviorment, {
        headers: {
          Authorization: `Bearer ${token}`,
          "isBackTesting": isBackTesting + "",
          
        }
      });
      setRows(response.data);
    } catch (error) {
      console.error('Error fetching records:', error);
    }
  };
  useEffect(() => {
    
    const cleanup = initHeightObserver(); // Initialize the height observer

    const handleMessage = (event) => {
      console.log(" CARGANDO REACT EVENTO " + event + " - " + event.data.type);
      if (event.data.token) {
        setToken(event.data.token);
        setIsBackTesting(event.data.isBackTesting);
        fetchRecords(event.data.token,event.data.isBackTesting)
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
      cleanup(); // Cleanup the observer on unmount
    };
  });



  const saveRecord = async (record,field) => {

    try {
 
      await axios.post(enviorment, record, {
        headers: {
          Authorization: `Bearer ${token}`,
          isBackTesting: isBackTesting
        }
      });
    } catch (error) {
      console.error('Error saving record:', error);
    
    }
    if(field === 'fecha'){
      setEditing({});
    }
 
  };

  const deleteRecord = async (id) => {
    try {
      await axios.delete(enviorment+"/"+id, {
        headers: {
          Authorization: `Bearer ${token}`,
          isBackTesting: isBackTesting
        }
      });
    } catch (error) {
      console.error('Error deleting record:', error);
    }
  };

  const calculateAccumulated = (rows) => {
    let accumulated = 0;
    return rows.map(row => {
      if (row) {
        const beneficioNeto = parseFloat(row.beneficioNeto) || 0;
        accumulated += beneficioNeto;
        return { ...row, acumulado: accumulated.toFixed(2) };
      }
      return row;
    });
  };

  const handleChange = (id, field, value) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        const updatedRow = { ...row, [field]: value };
 
        if (field === 'ganancia' || field === 'comision') {
          const ganancia = parseFloat(updatedRow.ganancia.replace(",", ".").replace("$", "")) || 0;
          const comision = parseFloat(updatedRow.comision.replace(",", ".").replace("$", "")) || 0;
          const beneficioNeto = ganancia - comision;
          updatedRow.beneficioNeto = beneficioNeto.toFixed(2);
          updatedRow.rentabilidad = ((beneficioNeto / accountSize) * 100).toFixed(2);
        }

        saveRecord(updatedRow,field);
   
        return updatedRow;
      }
      return row;
    });
    setRows(calculateAccumulated(newRows));

    if (field === 'fecha') {
      console.log("Date field updated");
      setEditing({});
    }
  };

  const handleBlur = (id) => {
    console.log("HANDLE BLUR " + id);
    const updatedRow = rows.find(row => row.id === id);
    setEditing({});

    console.log("HANDLE BLUR updatedRow " + JSON.stringify(updatedRow));
  
    setOpenSelect(null);
  };
  
  const handleAddRow = () => {
   /* const newRow = { id: rows.length + 1, activo: 'EURUSD', fecha: '24.07.2024', estrategia: 'BLUE A', direccion: 'LONG', tipoEntrada: 'SRTR', rr: '1.253', resultado: 'Stop Loss', ganancia: '0', comision: '0', beneficioNeto: '0', rentabilidad: '0', acumulado: '0' };
    const newRows = calculateAccumulated([...rows, newRow]);
    setRows(newRows);
    saveRecord(newRow); // Save new row
*/
    window.parent.postMessage({ type: 'openModalNewTrade' }, '*');
  };

  const handleDeleteRow = async (id) => {
    const rowToDelete = rows.find(row => row.id === id);
    if (rowToDelete) {
      await deleteRecord(rowToDelete.id);
      const newRows = rows.filter(row => row.id !== id);
      setRows(calculateAccumulated(newRows));
      
      // Adjust current page if necessary
      const newTotalPages = Math.ceil(newRows.length / rowsPerPage);
      if (page >= newTotalPages) {
        setPage(Math.max(0, newTotalPages - 1));
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (id, field) => {
    if(editing.id === id && editing.field === field && editing.field !== 'fecha'){
      setEditing({});
      return;
    }

    setEditing({ id, field });
    if (field === 'estrategia' || field === 'direccion' || field === 'resultado' || field === 'fecha') {
      setOpenSelect(id + field);
    }
  };
 
  const calculateTotals = () => {
    const totals = {
      ganancia: 0,
      comision: 0,
      beneficioNeto: 0,
      rentabilidad: 0,
      acumulado: 0,
      totalRR: 0,
      validRRCount: 0, // Añadimos un contador para RR válidos
    };
    rows.forEach(row => {
      totals.ganancia += parseFloat(row.ganancia) || 0;
      totals.comision += parseFloat(row.comision) || 0;
      totals.beneficioNeto += parseFloat(row.beneficioNeto) || 0;
      totals.acumulado += parseFloat(row.acumulado) || 0;
      
      const rrValue = parseFloat(row.rr);
      if (!isNaN(rrValue)) {
        totals.totalRR += rrValue;
        totals.validRRCount++; // Incrementamos solo para RR válidos
      }
    });
    totals.rentabilidad = (totals.beneficioNeto / accountSize) * 100;
    return totals;
  };

  const calculateAverages = (totals) => {
    const count = rows.length;
    const averages = {
      ganancia: (totals.ganancia / count).toFixed(2),
      comision: (totals.comision / count).toFixed(2),
      beneficioNeto: (totals.beneficioNeto / count).toFixed(2),
      rentabilidad: ((totals.beneficioNeto / accountSize) * 100).toFixed(2),
      acumulado: (totals.acumulado / count).toFixed(2),
      rr: totals.validRRCount > 0 ? (totals.totalRR / totals.validRRCount).toFixed(2) : 'N/A',
    };
    return averages;
  };

  const totals = calculateTotals();
  const averages = calculateAverages(totals);

  if (!rows) return null; // Asegúrate de que `rows` esté definido

  const filterBar = (
    <div className="sticky-filter-bar">
      <TextField
        name="search"
        placeholder="Buscar..."
        value={filters.search}
        onChange={handleFilterChange}
        className="filter-search"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="search-icon"/>
            </InputAdornment>
          ),
        }}
      />
      <Select
        name="estrategia"
        value={filters.estrategia}
        onChange={handleFilterChange}
        displayEmpty
        className="filter-select gray-text"
        renderValue={(selected) => selected || "Estrategia"}
      >
         <MenuItem value="">Quitar filtro</MenuItem>
        <MenuItem value="BLUE">BLUE</MenuItem>
        <MenuItem value="GREEN">GREEN</MenuItem>
        <MenuItem value="RED">RED</MenuItem>
        <MenuItem value="PINK">PINK</MenuItem>
        <MenuItem value="WHITE">WHITE</MenuItem>
        <MenuItem value="BLACK">BLACK</MenuItem>
  
      </Select>

      <Select
        name="direccion"
        value={filters.direccion}
        onChange={handleFilterChange}
        displayEmpty
        className="filter-select gray-text"
        renderValue={(selected) => selected || "Dirección"}
          
      >
        <MenuItem value="">Quitar filtro</MenuItem>
        <MenuItem value="LONG">LONG</MenuItem>
        <MenuItem value="SHORT">SHORT</MenuItem>
      </Select>
      <Select
        name="resultado"
        value={filters.resultado}
        onChange={handleFilterChange}
        displayEmpty
        className="filter-select gray-text"
        renderValue={(selected) => selected || "Resultado"}
      >
        <MenuItem value="">Quitar filtro</MenuItem>
        <MenuItem value="Stop Loss">Stop Loss</MenuItem>
        <MenuItem value="Take Profit">Take Profit</MenuItem>
        <MenuItem value="Break Even">Break Even</MenuItem>
        <MenuItem value="Partial">Partial</MenuItem>
      </Select>
      <Button  onClick={handleAddRow} sx={styles.button} className="nuevo-trade-button right-aligned">+ Nuevo Trade</Button>
    </div>
    
  );
   // Add this function to filter the rows
   const filteredRows = rows.filter(row => {
    return (
      (filters.search === '' || Object.values(row).some(value => String(value).toLowerCase().includes(filters.search.toLowerCase()))) &&
      (filters.estrategia === '' || row.estrategia === filters.estrategia) &&
      (filters.direccion === '' || row.direccion === filters.direccion) &&
      (filters.resultado === '' || row.resultado === filters.resultado)
    );
  });


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    
    
      {filterBar}
      <TableContainer component={Paper} sx={styles.table} className="custom-table-container" >
        <Table className="gfg">
          <TableBody>
            {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <TableRow key={row.id} sx={styles.tableRow} style={{ marginBottom: '10px', borderRadius: '10px', overflow: 'hidden' }}>
                <TableCell sx={styles.cell}>  
                  <div className="cell-content">
                    <span className="column-name">#id</span>
                    <span className="cell-value">{row.id}</span>
                  </div>
                </TableCell>
                <TableCell sx={styles.cell} onClick={() => handleEdit(row.id, 'activo')}>
                  <div className="cell-content">
                    <span className="column-name">activo</span>
                    <span className="cell-value">                  
                    {editing.id === row.id && editing.field === 'activo' ? (
                      <TextField
                        value={row.activo}
                        onChange={(e) => handleChange(row.id, 'activo', e.target.value)}
                        onBlur={() => handleBlur(row.id)}
                        autoFocus
                        InputProps={{
                          style: styles.input,
                          className: 'activo-input'  // Add this line
                        }}
                      />
                      ) : (
                        row.activo
                      )}
                  </span>
                  </div>
                </TableCell>
                <TableCell data-column="fecha" sx={styles.cell} onClick={() => handleEdit(row.id, 'fecha')}>
                  <div className="cell-content">
                    <span className="column-name">fecha</span>
                    <span className="cell-value">                  
                        {editing.id === row.id && editing.field === 'fecha' ? (
                            <DatePicker
                            value={dayjs(row.fecha)}
                            onAccept={(date) => {
                              handleChange(row.id, 'fecha', date ? date.format('DD.MM.YY') : '');
                              handleBlur(row.id);
                            }}
                            open={openSelect === row.id + 'fecha'}
                            className='datePickerRoot'
                            onClose={() => setOpenSelect(null)}
                            renderInput={(params) => <TextField {...params} autoFocus InputProps={{
                              style: styles.input,
                            }} />}
                            />
                        ) : (
                          row.fecha
                        )}
                    </span>
                  </div>
                  
                </TableCell>
                <TableCell sx={styles.cell} onClick={() => handleEdit(row.id, 'estrategia')}>            
                  <div className="cell-content">
                    <span className="column-name">
                      estrategia
                    </span>
                    <span className="cell-value">
                      {editing.id === row.id && editing.field === 'estrategia' ? (
                        <FormControl fullWidth size="small">
                          <Select
                            value={row.estrategia}
                            onChange={(e) => {
                              handleChange(row.id, 'estrategia', e.target.value);
                              handleBlur(row.id);
                            }}
                            onBlur={() => handleBlur(row.id)}
                            autoFocus
                            open={openSelect === row.id + 'estrategia'}
                            onClose={() => setOpenSelect(null)}
                            sx={{
                              height: '24px',
                              '& .MuiSelect-select': {
                                paddingTop: '0',
                                paddingBottom: '0',
                                display: 'flex',
                                alignItems: 'center',
                              },
                            }}
                          >
                            <MenuItem value="BLUE" sx={{ fontSize: '0.8rem', padding: '2px 8px' }}>BLUE</MenuItem>
                            <MenuItem value="GREEN" sx={{ fontSize: '0.8rem', padding: '2px 8px' }}>GREEN</MenuItem>
                            <MenuItem value="RED" sx={{ fontSize: '0.8rem', padding: '2px 8px' }}>RED</MenuItem>
                            <MenuItem value="PINK" sx={{ fontSize: '0.8rem', padding: '2px 8px' }}>PINK</MenuItem>
                            <MenuItem value="WHITE" sx={{ fontSize: '0.8rem', padding: '2px 8px' }}>WHITE</MenuItem>
                            <MenuItem value="BLACK" sx={{ fontSize: '0.8rem', padding: '2px 8px' }}>BLACK</MenuItem>
                            {/* Add more options as needed */}
                          </Select>
                        </FormControl>
                      ) : (
                        <Chip
                          label={row.estrategia}
                          sx={{
                            backgroundColor: '#3d5afe',
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontSize: '0.8rem',
                            height: '24px',
                            borderRadius: '4px',
                          }}
                        />
                      )}
                    </span>
                  </div>
                </TableCell>
                <TableCell data-column="direccion" sx={styles.cell} onClick={() => handleEdit(row.id, 'direccion')}>
                 <div className="cell-content">
                    <span className="column-name">
                      dirección
                    </span>
                    <span className="cell-value">
                      {editing.id === row.id && editing.field === 'direccion' ? (
                        <FormControl fullWidth>                    
                          <Select
                            value={row.direccion}
                            onChange={(e) => {
                              handleChange(row.id, 'direccion', e.target.value);
                              handleBlur(row.id);
                            }}
                            onBlur={() => handleBlur(row.id)}
                            open={openSelect === row.id + 'direccion'}
                            onClose={() => setOpenSelect(null)}
                            autoFocus
                            sx={{
                              height: '24px',
                              '& .MuiSelect-select': {
                                paddingTop: '0',
                                paddingBottom: '0',
                                display: 'flex',
                                alignItems: 'center',
                              },
                            }}
                          >
                            <MenuItem value="LONG">LONG</MenuItem>
                            <MenuItem value="SHORT">SHORT</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <Chip
                          label={row.direccion}
                          sx={{
                            backgroundColor: '#3d5afe',
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontSize: '0.8rem',
                            height: '24px',
                            borderRadius: '4px',
                          }}
                        />                    
                      )}
                    </span>
                  </div>
                  
                </TableCell>
                {isBackTesting && (
                <TableCell data-column="rr" sx={styles.cell} onClick={() => handleEdit(row.id, 'rr')}>
                  <div className="cell-content">
                    <span className="column-name">rr</span>
                    <span className="cell-value">
                      {editing.id === row.id && editing.field === 'rr' ? (
                        <TextField
                          value={row.rr}
                          onChange={(e) => handleChange(row.id, 'rr', e.target.value)}
                          onBlur={() => handleBlur(row.id)}
                          autoFocus
                          InputProps={{
                            style: styles.input,
                            className: 'activo-input'  // Add this line
                          }}
                        />
                      ) : (
                        row.rr
                      )}
                    </span>
                  </div>
             
                </TableCell>
                   )}
                <TableCell  sx={styles.cell} onClick={() => handleEdit(row.id, 'resultado')}>
                  <div className="cell-content">
                    <span className="column-name">
                      resultado
                    </span>
                    <span className="cell-value">
                      {editing.id === row.id && editing.field === 'resultado' ? (
                        <Select
                          value={row.resultado}
                          onChange={(e) => handleChange(row.id, 'resultado', e.target.value)}
                          onBlur={() => handleBlur(row.id)}
                          open={openSelect === row.id + 'resultado'}
                          onClose={() => setOpenSelect(null)}
                          autoFocus
                          sx={{
                            height: '24px',
                            '& .MuiSelect-select': {
                              paddingTop: '0',
                              paddingBottom: '0',
                              display: 'flex',
                              alignItems: 'center',
                            },
                          }}
                        >
                          {resultOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.value}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : (
                        <span
                          className="result-chip"
                          style={{
                            backgroundColor: 'transparent',
                            color:  resultOptions.find(opt => opt.value === row.resultado)?.color || '#ffffff',
                            padding: '2px 8px',
                            border: '2px solid '+  resultOptions.find(opt => opt.value === row.resultado)?.color || '#ffffff',
                            borderRadius: '5px',
                            fontSize: '0.8rem',
                            fontWeight: 'regular',
                          }}
                        >
                          {row.resultado}
                        </span>
                      )}
                    </span>
                  </div>
                </TableCell>
                {!isBackTesting && (
                <TableCell data-column="ganancia" sx={styles.cell} onClick={() => handleEdit(row.id, 'ganancia')}>
                  <div className="cell-content">
                    <span className="column-name">P&L</span>
                    <span className="cell-value">
                      {editing.id === row.id && editing.field === 'ganancia' ? (
                        <TextField
                          value={row.ganancia}
                          onChange={(e) => handleChange(row.id, 'ganancia', e.target.value)}
                          onBlur={() => handleBlur(row.id)}
                          autoFocus
                          InputProps={{
                            style: styles.input,
                            className: 'activo-input'  // Add this line
                          }}
                        />
                      ) : (
                        <span style={{ color: isNaN(parseFloat(row.ganancia)) ? 'white' : (parseFloat(row.ganancia) >= 0 ? '#4caf50' : '#f44336') }}>
                         {row.ganancia === '-' ? ('-') : (row.ganancia + '$')}
                        </span>
                      )}
                    </span>
                  </div>
                </TableCell>
                )}
                <TableCell data-column="comision" sx={styles.cell} onClick={() => handleEdit(row.id, 'comision')}>              
                <div className="cell-content">
                  <span className="column-name">comisión</span>
                  <span className="cell-value" style={{ color: '#ffeb3b' }}>                 
                    {editing.id === row.id && editing.field === 'comision' ? (
                      <TextField
                        value={row.comision}
                        onChange={(e) => handleChange(row.id, 'comision', e.target.value)}
                        onBlur={() => handleBlur(row.id)}
                        autoFocus
                        InputProps={{
                          style: styles.input,
                          className: 'activo-input'  // Add this line
                        }}
                      />
                    ) : (
                      `- ${row.comision} $`
                    )}
                  </span>
                </div>
              </TableCell>
                <TableCell data-column="beneficioNeto" sx={styles.cell}>
                  <div className="cell-content">
                    <span className="column-name">beneficio</span>
                    <span className="cell-value">{row.beneficioNeto}</span>
                  </div>
                </TableCell>
                <TableCell data-column="rentabilidad" sx={styles.cell}>
                  <div className="cell-content">
                    <span className="column-name">rent.</span>
                    <span className="cell-value">{row.rentabilidad}%</span>
                  </div>
                  
                </TableCell>
                {/*    <TableCell sx={styles.cell}>
                  <div className="cell-content">
                    <span className="column-name">acumulado</span>
                    <span className="cell-value">{row.acumulado}</span>
                  </div>             
                </TableCell> */}  
                <TableCell sx={styles.cell}>
                <div className="cell-content">
                <span className="column-name"></span>
                <div className="actions-container">
            
                  
                  <Button
                    className='notas-button'
                    onClick={() => handleNotasClick(row.id,false)}
                    variant="outlined"
                    size="small"
                  >
                    Notas
                  </Button>
                  {!isBackTesting && (
                  <Button
                    className='notas-button'
                    onClick={() => handleNotasClick(row.id,true)}
                    variant="outlined"
                    size="small"
                  >
                    ASR
                  </Button>
                  )}
                  <Button
                    className='notas-button'
                    onClick={() => handleDeleteRow(row.id)}
                    variant="outlined"
                    size="small"
                  >
                    <DeleteForever />
                  </Button>          
                </div>
              </div> 

                </TableCell>
              </TableRow>
            ))}

          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell sx={styles.cell}>
                    <div className="cell-content">
                      <span className="column-name">totales</span>
                      <span className="cell-value">                  
                        {rows.length}
                      </span>
                   </div>
              </TableCell>
              <TableCell colSpan={4}   sx={styles.cell}></TableCell>
            
              <TableCell sx={styles.cell}>
                  <div className="cell-content">
                    <span className="column-name">media</span>
                    <span className="cell-value">                  
                      {averages.rr !== 'N/A' ? averages.rr : 'No disponible'}
                    </span>
                  </div>
                </TableCell>
    
                <TableCell sx={styles.cell}></TableCell>
              <TableCell  sx={styles.cell}>
                   <div className="cell-content">
                      <span className="column-name">suma</span>
                      <span className="cell-value">                  
                        {totals.ganancia.toFixed(2)} $
                      </span>
                   </div>       
              </TableCell>
              <TableCell sx={styles.cell}>
                  <div className="cell-content">
                      <span className="column-name">suma</span>
                      <span className="cell-value">                  
                        {totals.comision.toFixed(2)} $
                      </span>
                   </div>
        
                </TableCell>
                <TableCell sx={styles.cell}>
                <div className="cell-content">
                      <span className="column-name">suma</span>
                      <span className="cell-value">                  
                      {totals.beneficioNeto.toFixed(2)} $
                      </span>
                   </div>
                </TableCell>
                <TableCell sx={styles.cell}>
                  <div className="cell-content">
                      <span className="column-name">suma</span>
                      <span className="cell-value">                  
                        {averages.rentabilidad} %
                      </span>
                   </div>
              
                </TableCell>
                <TableCell sx={styles.cell}></TableCell>
            </TableRow>

            </TableFooter>
        </Table>

        <TablePagination
          rowsPerPageOptions={[10,50]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage=''
          className="custom-pagination" // Add this class
        />
 
      </TableContainer>
    
      <Button className='bottomNewTrade' onClick={handleAddRow} sx={styles.button}>+ Nuevo Trade</Button>   
    </LocalizationProvider>
  );
}

export default JournalTable;